export default "__VITE_ASSET__DQQOEZLl__"